import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { CalendarVisibility } from './CalendarVisibility';
import { DefaultCalendar } from './DefaultCalendar';
import { EventAvailability } from './EventAvailability';
import { ExternalCalendarSync } from './ExternalCalendarSync';
import { WeekStartDay } from './WeekStartDay';
import { CalendarsList } from '../../../../SideBar';
import { syncErrorRootEmailAtom, useCalendarContext } from '../../../../../data-access';
import { useHandleCalSyncError } from '../../../../../hooks';
import { ReactComponent as CalendarIcon } from '../../../../../assets/tabs/settings-tab/calendar-icon.svg';
import './CalendarSection.scss';

const CalendarSection: FC = () => {
  const { t } = useTranslation();
  const { calendarsMeta, visibleCalendarIds, isFetchingCalendars, handleSelectCalendar } =
    useCalendarContext();
  const syncErrorRootEmail = useRecoilValue(syncErrorRootEmailAtom);
  const { handleConnect, handleDisconnect, isConnectingCalendars, isDisconnectingCalendars } =
    useHandleCalSyncError({ syncErrorRootEmail });

  return (
    <Stack gap={2} className="calendar-section">
      <Typography variant="h3" className="calendar-section__title">
        {t('settings.nav.calendars')}
      </Typography>

      <Stack gap={1.5} className="calendar-section__calendar-list-card">
        <Stack
          gap={1}
          direction="row"
          alignItems="center"
          className="calendar-section__group-header"
        >
          <CalendarIcon />
          <Typography variant="body1" className="calendar-section__group-title">
            {t('task.sidebar.integrations')}
          </Typography>
        </Stack>

        <CalendarsList
          calendarsMeta={calendarsMeta}
          visibleCalendarIds={visibleCalendarIds}
          isFetchingCalendars={isFetchingCalendars}
          syncErrorRootEmail={syncErrorRootEmail}
          onSelectCalendar={handleSelectCalendar}
          onDisconnectCalendar={handleDisconnect}
          onConnectCalendar={handleConnect}
          isConnectingCalendars={isConnectingCalendars}
          isDisconnectingCalendars={isDisconnectingCalendars}
          className="calendar-section__calendars-list"
          defaultExpanded={false}
        />
      </Stack>

      <DefaultCalendar />
      <EventAvailability />
      <ExternalCalendarSync />
      <WeekStartDay />
      <CalendarVisibility />
    </Stack>
  );
};

export default CalendarSection;
